module.exports = __webpack_public_path__ + "static/media/barmag1b2.0989fba2.jpg";